<template>
	<div style="overflow: hidden;height: 3200px;background: white;">
    <van-nav-bar title="发展历程" left-arrow @click-left="$router.back()" left-text="返回" />
		<van-row>
      <a href="/home"><van-col span="24"><img style="float: left; " src="@/assets/page/title.gif" /></van-col></a>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 20px;color: #EE7800;"><h1>发展历程</h1></van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2014</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m1.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>
						2014-2016年，春雪会计制定了三年发展规划，向更高的目标发起冲击；春雪人将一如既地往以专业的技能、替对方着想的宗旨为客户服务，将一如既往地以规范行业标准、带动行业高速发展为己任，树立会计服务行业良好形象，迎接会计服务行业新的辉煌。
					</li>
				</ul>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2013</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m2.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>
						春雪会计成立15周年，员工近千名，分公司26家，培训学校分校23家，服务客户超过2万家；春雪会计当选为北京市朝阳区代理记账协会副会长并荣获“全国会计服务业公众满意十大领军企业”；成为北京联合大学生物化学工程学院会计学专业实习基地。
					</li>
				</ul>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2012</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m3.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>春雪集团拥有40余家直营分公司，包括24个分公司，18个分校，4个外阜加盟校，服务客户近2万家。</li>
				</ul>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2011</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m4.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>所有分公司启用触摸屏取票、收费管理系统，北京春雪会计服务有限公司荣获“全国会计服务业公众满意十大领军企业”称号。</li>
				</ul>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2008</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m5.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>被北京市地税局表彰为朝阳区纳税大户，近千名员工共同参加盛大的春雪10周年庆典，北京春雪会计学校荣获“助威2008评选活动荣誉证书”</li>
				</ul>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2007</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m6.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>
						春雪成为北京市税法宣传定点代表单位，北京春雪人力资源管理服务有限责任公司成立，北京春雪登记注册代理事务所成为北京经纪人协会会员单位。北京春雪会计培训学校被朝阳区教委评为2007年度优秀教育机构。
					</li>
				</ul>
			</van-col>
		</van-row>
		<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2006</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m7.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>总部入驻万达广场，北京春雪登记注册代理事务所成立，建立万达VIP室。</li>
				</ul>
			</van-col>
		</van-row>
			<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2005</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m8.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>北京春雪培训学校成立，设立7家直营分校。</li>
				</ul>
			</van-col>
		</van-row>
			<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2004</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m9.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>自行开发的CX数据管理系统投入使用。</li>
				</ul>
			</van-col>
		</van-row>

				<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>2003</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m10.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>春雪成立五周年，设立9家分公司。</li>
				</ul>
			</van-col>
		</van-row>

				<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>1999</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m11.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>服务客户200余家。</li>
				</ul>
			</van-col>
		</van-row>

				<van-row>
			<van-col span="24" style="text-align: left;margin-left: 40px;"><h1>1998</h1></van-col>
		</van-row>
		<van-row type="flex" justify="left" style="margin-bottom: 5px;">
			<van-col span="6"><img style="width: 140px;height:100px; border: 1px solid #98C313; margin:12px 20px;  " src="@/assets/page/m12.jpg" alt="" /></van-col>

			<van-col span="12" offset="5" style="text-align: left;margin-top: 12px;font-size:16px;margin-bottom: 12px;font-weight:260 ;">
				<ul style="margin-left: 10px;font-weight: 500;">
					<li>北京春雪会计服务有限公司成立。</li>
				</ul>
			</van-col>
		</van-row>
	</div>
</template>

<script>
export default {
	name: 'page5',
	data() {
		return {};
	}
};
</script>

<style scoped="scoped">
img {
	width: 100%;
	height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/page/company.vue